<template>
    <div class="popup-msg-component-container scroll-bar">
        <div v-if="loadingPopupMsg" class="spinner-container">
            <div class="spinner">
                <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
            </div>
        </div>
        <div v-else class="popup-msg-component-wrapper scroll-bar">
            <div class="popup-msg-container" :class="[{'green-border' : popupObj.popupType == 'confirm' || popupObj.popupType == 'info', 'grey-border' : popupObj.popupType == 'error', 'magenta-border' : popupObj.popupType == 'warning' && popupObj.title != 'no_training_possible', 'red-border' : popupObj.popupType == 'warning' && popupObj.title == 'no_training_possible'}]">
                <div class="popup-msg-title-content-container">
                    <div class="popup-msg-title-content-wrapper" :class="[{'green-bg' : popupObj.popupType == 'confirm' || popupObj.popupType == 'info', 'grey-bg' : popupObj.popupType == 'error', 'magenta-bg' : popupObj.popupType == 'warning' && popupObj.title != 'no_training_possible', 'red-bg' : popupObj.popupType == 'warning' && popupObj.title == 'no_training_possible'}]">
                        <div class="popup-msg-title-text-container">
                            <p>{{ $t(popupObj.title) }}</p>
                        </div>
                        <div v-if="popupObj.title == 'your_trainings'" class="popup-msg-title-icon-container">
                            <img src="../../assets/icons/question_mark.png" alt="Info image">
                        </div>
                    </div>
                </div>

                <div v-if="popupObj.title == 'confirm_cancellation'" class="cancelling-event-reasons-select-menu-container">
                    <div class="cancelling-reason-question-text-container">
                        <p>{{ $t('what_is_the_reason') }} <span class="required">&#42;</span></p>
                    </div>
                    <div class="cancelling-event-reasons-select-menu-list-container">
                        <ul class="cancelling-event-reasons-select-menu-list">
                            <li class="reason-item-container" v-for="(reason, index) in cancellingReasonsArr" :key="index" @click="updateCancellationReasonOption(index)">
                                <div class="option-checkbox-container reason-option-checkbox-container">
                                    <div class="option-checkbox-wrapper reason-option-checkbox-wrapper">
                                        <div v-if="index == selectedCancellationReasonIndex" class="option-checkbox-img-container reason-option-checkbox-img-container">
                                            <img src="../../assets/icons/check.png" alt="Check icon">
                                        </div>
                                    </div>
                                </div>
                                <div class="option-checkbox-text-container reason-text-container">
                                    <p>{{ $t(reason) }}</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div v-if="noCancellationReasonSelected" class="select-cancellation-reason-container">
                        <p>{{ $t('select_cancellation_reason') }}</p>
                    </div>

                    <div class="optional-msg-container">
                        <p>{{ $t('message') }}</p>
                        <textarea class="scroll-bar" name="optionalMsg" id="optionalMsg" rows="2" :placeholder="$t('type_message_here')" @keyup="updateCancellationReasonMsg()"></textarea>
                    </div>
                </div>

                <div v-if="popupObj.text" class="popup-msg-text-container">
                    <p v-if="popupObj.title == 'your_trainings'">{{ $t(popupObj.text , {count: popupObj.rescheduleLimit}) }}</p>
                    <p v-else>{{ $t(popupObj.text) }}</p>
                    <p v-if="popupObj.activePartnerEvent">{{ $t('duo_partner_confirmation_notice') }}</p>
                    <!-- <p>{{ $t(popupObj.text) }}</p> -->
                </div>

                <div v-if="popupObj.clientName" class="duo-clients-options-container">
                    <div class="option-content-container client-option-container">
                        <div class="option-checkbox-container filter-option-checkbox-container">
                            <div class="option-checkbox-wrapper filter-option-checkbox-wrapper">
                                <div class="option-checkbox-img-container filter-option-checkbox-img-container">
                                    <img src="../../assets/icons/check.png" alt="Check icon">
                                </div>
                            </div>
                        </div>

                        <div class="option-checkbox-text-container client-name-container">
                            <p>{{ popupObj.clientName }}</p>
                        </div>
                    </div>

                    <div v-if="!popupObj.partnerEventCancelled" class="option-content-container partner-option-container" @click="togglePartnerSelection(popupObj.partnerEventId)">
                        <div class="option-checkbox-container filter-option-checkbox-container">
                            <div class="option-checkbox-wrapper filter-option-checkbox-wrapper">
                                <div v-if="partnerEventId" class="option-checkbox-img-container filter-option-checkbox-img-container">
                                    <img src="../../assets/icons/check.png" alt="Check icon">
                                </div>
                            </div>
                        </div>

                        <div v-if="popupObj.partnerName" class="option-checkbox-text-container partner-name-container">
                            <p>{{ popupObj.partnerName }}</p>
                        </div>
                    </div>
                </div>

                <div class="popup-msg-action-btns-container">
                    <div class="btn-container close-popup-msg-btn-container" @click="closePopupMsg">
                        <div class="btn close-popup-msg-btn">
                            <img src="../../assets/icons/cancel_icon.png" alt="Close image">
                        </div>
                    </div>
                    <div v-if="popupObj.actionBtn" class="btn-container confirm-popup-msg-btn-container" @click="popupObj.actionBtn">
                        <div class="btn confirm-popup-msg-btn">
                            <img src="../../assets/icons/check.png" alt="Check image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopupMsg',
    props: {
        popupObj: Object,
        closePopupMsg: Function,
        loadingPopupMsg: Boolean,
        partnerEventId: String,
        togglePartnerSelection: Function,
        updateCancellationReason: Function,
        noCancellationReasonSelected: Boolean,
    },
    data() {
        return {
            cancellingReasonsArr: ['other_commitment', 'sick', 'injury', 'vacation', 'other_reason'],
            selectedCancellationReasonIndex: null,
            // selectCancellationReason: null,
            cancellingReasonOption: null,
            cancellingMsg: null,
        }
    },
    methods: {
        selectCancellationReason: function(index) {
            this.selectedCancellationReasonIndex = index;
            // console.log(this.$t(this.cancellingReasonsArr[index]));
            // this.selectCancellationReason = this.$t(this.cancellingReasonsArr[index]);
        },
        updateCancellationReasonOption: function(index) {
            this.selectedCancellationReasonIndex = index;
            this.cancellingReasonOption = this.$t(this.cancellingReasonsArr[index]);
            // console.log("this.cancellingReasonOption: " + this.cancellingReasonOption);
            const newCancellationReasonObj = {
                reason: this.cancellingReasonOption,
                message: this.cancellingMsg,
            }
            this.updateCancellationReason(newCancellationReasonObj);
        },
        updateCancellationReasonMsg: function() {
            const msg = document.getElementById("optionalMsg").value;
            this.cancellingMsg = msg;
            // console.log("msg: " + msg);
            const newCancellationReasonObj = {
                reason: this.cancellingReasonOption,
                message: this.cancellingMsg,
            }
            this.updateCancellationReason(newCancellationReasonObj);
        },
        // handleTextareaFocus: function(event) {
        //     // Scroll to the textarea's position when it gains focus.
        //     console.log("Executing handleTextareaFocus...");
        //     // console.log("event.target.offsetTop: " + event.target.offsetTop);
        //     // window.scrollTo(0, event.target.offsetTop);
        //     // popup-msg-container
        //     if (event) {
        //         console.log("event.target.offsetTop: " + event.target.offsetTop);
        //         const popupContainer = document.querySelector(".popup-msg-container");
        //         if (popupContainer) {
        //             // console.log();
        //             popupContainer.style.marginBottom = '300px'; // Adjust this value to match your keyboard's height
        //         }
        //     }
        //     // textarea.style.marginBottom = '300px'; // Adjust this value to match your keyboard's height
        //     // textarea.scrollIntoView({ behavior: 'smooth' });
        // }
    },
    // mounted() {
    //     const textarea = document.getElementById("optionalMsg");
    //     console.log("textarea from mounted: " + textarea);
    //     if (textarea) {
    //         textarea.addEventListener('focus', this.handleTextareaFocus);
    //     }
    // },
    // beforeDestroy() {
    //     // Clean up the event listner to avoid memory leaks.
    //     const textarea = document.getElementById("optionalMsg");
    //     console.log("textarea from beforeDestroy: " + textarea);
    //     if (textarea) {
    //         textarea.removeEventListener('focus', this.handleTextareaFocus);
    //     }
    // }
}

</script>

<style>
.popup-msg-component-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    /* align-items: center; */
    background: rgba(255, 255, 255, 0.75);
    z-index: 150;
    overflow: auto;
}

.popup-msg-component-container .spinner-container {
    flex: 1;
    width: 100%;
    /* height: 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-msg-component-container .spinner {
    width: 20% !important;
    max-width: 75px !important;
}

.popup-msg-component-container .popup-msg-component-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    /* padding: 20px 0; */
    overflow: auto;
}

.popup-msg-component-container .popup-msg-container {
    width: 85%;
    max-width: 500px;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 22px;
    background: #ffffff;
    margin: 20px 0;
    /* overflow: auto; */
    /* padding-bottom: 25px; */
}

.popup-msg-component-container .green-border {
    border: 2px solid #92d400;
}

.popup-msg-component-container .magenta-border {
    border: 2px solid #E4007C;
}

.popup-msg-component-container .grey-border {
    border: 2px solid #616365;
}

.popup-msg-component-container .red-border {
    border: 2px solid #cb061d;
}

.popup-msg-component-container .popup-msg-title-content-container {
    width: 100%;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
}

.popup-msg-component-container .popup-msg-title-content-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 6px 15px 5px;
}

.popup-msg-component-container .green-bg {
    background: #92d400;
}

.popup-msg-component-container .magenta-bg {
    background: #E4007C;
}

.popup-msg-component-container .grey-bg {
    background: #616365;
}

.popup-msg-component-container .red-bg {
    background: #cb061d;
}

.popup-msg-component-container .popup-msg-title-text-container {
    flex: 1;
}

.popup-msg-component-container .popup-msg-title-text-container p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #ffffff;
}

.popup-msg-component-container .popup-msg-title-icon-container {
    width: 30px;
}

.popup-msg-component-container .popup-msg-title-icon-container img {
    width: 100%;
    filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(6%) hue-rotate(336deg) brightness(104%) contrast(102%);
}

[dir="rtl"] .popup-msg-component-container .popup-msg-title-icon-container img {
    transform: scaleX(-1);
}

.popup-msg-component-container .popup-msg-text-container,
.popup-msg-component-container .cancelling-event-reasons-select-menu-container {
    width: 100%;
    padding: 10px 15px;
}

.popup-msg-component-container .cancelling-reason-question-text-container {
    padding-bottom: 10px;
}

.popup-msg-component-container .cancelling-reason-question-text-container p {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
}

.popup-msg-component-container .required {
    color: #E4007C;
    font-size: 20px;
}

.popup-msg-component-container .popup-msg-text-container p {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
}

.popup-msg-component-container .cancelling-event-reasons-select-menu-list-container {
    padding: 10px 15px;
    border: 1px solid #d6d9d9;
    border-radius: 5px;
}

.popup-msg-component-container .cancelling-event-reasons-select-menu-list {
    width: 100%;
    padding: 5px 0;
}

.popup-msg-component-container .reason-item-container {
    width: max-content;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
}

.popup-msg-component-container .reason-item-container:last-child {
    margin-bottom: 0;
}

.popup-msg-component-container .optional-msg-container {
    width: 100%;
    padding-top: 15px;
}

.popup-msg-component-container .optional-msg-container p {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    padding-bottom: 10px;
}

.popup-msg-component-container .optional-msg-container textarea {
    width: 100%;
    resize: none;
    border: 1px solid #d6d9d9;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 22px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    outline: none;
}

.popup-msg-component-container .optional-msg-container textarea:focus {
    border: 1px solid #92d400; /* Change to your desired color */
}

.popup-msg-component-container .select-cancellation-reason-container {
    width: 100%;
    padding-top: 5px;
}

.popup-msg-component-container .select-cancellation-reason-container p {
    font-size: 14px;
    font-family: 'Open Sans Std', sans-serif;
    color: #cb061d;
}

.popup-msg-component-container .duo-clients-options-container {
    width: 100%;
    padding: 25px 15px 20px;
    /* border: 1px solid; */
}

.popup-msg-component-container .option-content-container {
    width: max-content;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.popup-msg-component-container .partner-option-container {
    padding-top: 25px;
}

.popup-msg-component-container .option-checkbox-container {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    border: 1px solid #d6d9d9;
    border-radius: 6px;
}

[dir="rtl"] .popup-msg-component-container .option-checkbox-container {
    margin-right: 0;
    margin-left: 15px;
}

.popup-msg-component-container .option-checkbox-wrapper {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-msg-component-container .option-checkbox-img-container {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-msg-component-container .option-checkbox-img-container img {
    width: 100%;
    filter: brightness(0) saturate(100%) invert(71%) sepia(53%) saturate(686%) hue-rotate(30deg) brightness(90%) contrast(114%);
}

.popup-msg-component-container .option-checkbox-text-container p {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
}

.popup-msg-component-container .popup-msg-action-btns-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 20px;
}

.popup-msg-component-container .btn-container {
    /* width: 90px; */
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    padding: 1px 30px;
    overflow: hidden;
    cursor: pointer;
}

.popup-msg-component-container .btn {
    /* width: 100%; */
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: 5px 0;
}

.popup-msg-component-container .close-popup-msg-btn-container {
    /* height: 37px; */
    background: #a0a1a3;
    
}

.popup-msg-component-container .confirm-popup-msg-btn-container {
    /* height: 37px; */
    background: #009df4;
    
}

.popup-msg-component-container .close-popup-msg-btn img {
    width: 70%;
}

.popup-msg-component-container .confirm-popup-msg-btn-container {
    margin-left: 40px;
}

[dir="rtl"] .popup-msg-component-container .confirm-popup-msg-btn-container {
    margin-left: 0;
    margin-right: 40px;
}

.popup-msg-component-container .confirm-popup-msg-btn img {
    width: 90%;
}



@media (max-width: 375px) {
    .popup-msg-component-container .popup-msg-title-text-container p {
        /* font-size: 22px; */
        font-size: calc(14px + 2vw);
    }

    .popup-msg-component-container .cancelling-reason-question-text-container p {
        /* font-size: 18px; */
        font-size: calc(10px + 2vw);
    }

    .popup-msg-component-container .required {
        /* font-size: 18px; */
        font-size: calc(10px + 2vw);
    }

    .popup-msg-component-container .reason-item-container {
        margin-bottom: 6px;
    }

    .popup-msg-component-container .option-checkbox-container {
        width: 25px;
        height: 25px;
    }

    .popup-msg-component-container .option-checkbox-text-container p {
        /* font-size: 18px; */
        font-size: calc(10px + 2vw);
    }

    .popup-msg-component-container .optional-msg-container p {
        /* font-size: 18px; */
        font-size: calc(10px + 2vw);
    }

    .popup-msg-component-container .optional-msg-container textarea {
        /* font-size: 18px; */
        font-size: calc(10px + 1.8vw);
    }

    .popup-msg-component-container .popup-msg-text-container p {
        /* font-size: 18px; */
        font-size: calc(10px + 2vw);
    }

    .popup-msg-component-container .btn-container {
        height: 35px;
        padding: 1px 25px;
    }

    .popup-msg-component-container .btn {
        width: 35px;
    }
}

@media (max-width: 375px) {
    .popup-msg-component-container .btn-container {
        height: 30px;
        padding: 1px 20px;
    }

    .popup-msg-component-container .btn {
        width: 30px;
    }
}

</style>